function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import { withIconWrapper } from '../../components/atoms/Icon/withIconWrapper';
import { jsx as ___EmotionJSX } from "@emotion/react";

var IconPractitioner = function IconPractitioner(props, ref) {
  return ___EmotionJSX("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none",
    ref: ref
  }, props), ___EmotionJSX("path", {
    d: "M12.0001 12C14.651 12 16.8001 9.85094 16.8001 7.20002C16.8001 4.54906 14.651 2.40002 12.0001 2.40002C9.34911 2.40002 7.20007 4.54906 7.20007 7.20002C7.20007 9.85094 9.34911 12 12.0001 12Z"
  }), ___EmotionJSX("path", {
    d: "M12 13.2C8.76002 13.2 2.40002 14.76 2.40002 18V20.4C2.40002 21 3.00002 21.6 3.60002 21.6H20.4C21 21.6 21.6 21 21.6 20.4V18C21.6 14.76 15.24 13.2 12 13.2ZM4.68002 18C4.68002 17.4 6.72002 16.32 9.24002 15.84L10.2 17.52L11.28 19.32H4.68002V18ZM19.32 19.32H12.72L13.8 17.52L14.76 15.84C17.28 16.32 19.32 17.52 19.32 18V19.32Z"
  }));
};

export default withIconWrapper( /*#__PURE__*/forwardRef(IconPractitioner));
//# sourceMappingURL=IconPractitioner.js.map